import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DefaultConfigurationPlaceholder, DefaultConfigUtils } from '../../models/default-config-placeholder';
import { User } from '../../models/user';

import { DefaultConfigPlaceholderService } from '../../services/default-config-placeholder.service';
import { ToastService } from 'src/app/services/toast.service';
import { GridSettings } from 'src/app/features/grid/classes/grid-settings.model';
import { GridColumnData } from 'src/app/features/grid/classes/grid-column-data.class';

@Component({
  selector: 'app-default-configs',
  templateUrl: './default-configs.component.html',
  styleUrls: ['./default-configs.component.scss'],
  providers: [DefaultConfigPlaceholderService],
  standalone: false,
})
export class DefaultConfigsComponent implements OnInit, OnDestroy {

  componentDestroyed$ = new Subject<boolean>();

  defaultConfigGridSettings = signal<GridSettings>(null);
  public gridLoading = signal<boolean>(true);
  
  allGroup: DefaultConfigurationPlaceholder[];
  selectedConfig: DefaultConfigurationPlaceholder;

  showFullMapping = false;
  monacoData = '';

  constructor(
    protected configService: DefaultConfigPlaceholderService,
    private toastService: ToastService,
    private router: Router,
    private user: User,
  ) {
  }

  ngOnInit(): void {
    this.defaultConfigGridSettings.set(this.setupGrid());
    this.getDefaultConfigs();
  }

  getDefaultConfigs(): void {
    this.configService.getAllDefaultConfigPlaceholders()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe({
        next: (r) => {
          this.allGroup = r;
          this.defaultConfigGridSettings.set(this.defaultConfigGridSettings().setData(this.allGroup));
        },
        error: (_error) => {
          this.toastService.toastCreate('Failed to load Default Configurations', 'Danger', {
            autoClose: false,
          });
        },
        complete: () => {
          this.defaultConfigGridSettings().loading.set(false);
        },
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  setupGrid(): GridSettings {
    return new GridSettings({
      selection: {
        enabled: true,
        selectionType: 'row',
        mode: 'single',
      },
      loading: this.gridLoading,
      dataKey: 'defaultConfigurationPlaceholderId',
      data: this.allGroup,
      fixedGrid: true,
      columns: [
        new GridColumnData({ width: '200px', field: 'name', header: 'Name'}),
        new GridColumnData({ width: '200px', field: 'endpointName', header: 'Destination'}),
        new GridColumnData({ width: '200px', field: 'dataSourceTypeId', header: 'DataSource'}),
        new GridColumnData({ width: '200px', field: 'typeDescription', header: 'Import Type'}),
        new GridColumnData({ width: '150px', field: 'isGeneric', header: 'Is Generic'}),
        new GridColumnData({ width: '270px', field: 'comments', header: 'Comments'}),
      ],
      sortMode: 'multiple',
      filter: {
        enabled: true,
        display: 'row',
        mode: 'row',
      },
      multisort: [
        {
          field: 'updatedDate',
          order: -1,
        },
      ],
    });
  }
      
  checkAccess(role: string[]): boolean {
    if (this.user.checkAccess(role)) {
      return true;
    } else {
      return false;
    }
  }

  selectionChangeHandler(event: DefaultConfigurationPlaceholder[]): void {
    this.selectedConfig = event[0];
    if (this.checkAccess(['LOSTalker.Integration'])) {
      this.router.navigate(['/editDefaultConfigs', this.selectedConfig.name]);
    }
  }

  goToAddPage(): void {
    if (this.checkAccess(['LOSTalker.Integration'])) {
      this.router.navigate(['/addDefaultConfigs']);
    }
  }

  initShowFullMapping() {
    const baseUtils = new DefaultConfigUtils();
    const filteredConfigs = baseUtils.filterGroup(this.allGroup, null, null, null, null);
    baseUtils.setUpBase(filteredConfigs);
    const tmpStr = baseUtils.buildStringFromBase();
    const formattedStr = baseUtils.formatXMLString(tmpStr);
    this.monacoData = formattedStr;
    this.showFullMapping = true;
  }

  initHideFullMapping() {
    this.showFullMapping = false;
  }

}
